import WorkerModelResponse from '@/api/models/WorkerModelResponse'
import ReservationModelResponse from '@/api/models/ReservationModelResponse'
import { IAgentState } from './interfaces/agent-state'

export default class AgentState implements IAgentState {
  public worker: WorkerModelResponse | null = null
  public reservations: ReservationModelResponse[] = []
}
